import React from 'react';
import { HelpTopic, getNextTopic, getPreviousTopic } from '../data/helpContent';
import HelpTopicView from './HelpTopicView';
import styles from '../styles/helpSystem.module.css';

interface HelpTourProps {
  currentTopic: HelpTopic;
  onNavigate: (topicId: string) => void;
  onSwitchToBrowse: () => void;
}

const HelpTour: React.FC<HelpTourProps> = ({ currentTopic, onNavigate, onSwitchToBrowse }) => {
  const nextTopic = getNextTopic(currentTopic.id);
  const prevTopic = getPreviousTopic(currentTopic.id);

  const navigationButtons = (
    <div className={styles.tourNavigation}>
      <button
        className={styles.navButton}
        onClick={() => prevTopic && onNavigate(prevTopic.id)}
        disabled={!prevTopic}
      >
        ◄ Previous
      </button>
      
      <button
        className={styles.directoryButton}
        onClick={onSwitchToBrowse}
      >
        📚 Browse Directory
      </button>
      
      <button
        className={styles.navButton}
        onClick={() => nextTopic && onNavigate(nextTopic.id)}
        disabled={!nextTopic}
      >
        Next ►
      </button>
    </div>
  );

  return (
    <div className={styles.tour}>
      {/* Navigation at top */}
      {navigationButtons}

      <HelpTopicView 
        topic={currentTopic} 
        showNavigation={true}
        onTopicClick={onNavigate}
      />

      {/* Navigation at bottom */}
      {navigationButtons}
    </div>
  );
};

export default HelpTour;

